import { render, staticRenderFns } from "./Resguardos.vue?vue&type=template&id=36f723fa"
import script from "./Resguardos.vue?vue&type=script&lang=js"
export * from "./Resguardos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports